import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";

interface HelpTipProps {
  content: string;
  side?: "top" | "bottom" | "left" | "right";
  testId?: string;
}

export function HelpTip({ content, side = "bottom", testId = "button-help-tip" }: HelpTipProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label="Help"
          data-testid={testId}
          className="text-muted-foreground"
        >
          <Info className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent side={side} className="text-sm leading-relaxed max-w-xs">
        {content}
      </PopoverContent>
    </Popover>
  );
}
